import * as t from 'io-ts';

export const aiChatMessageCodec = t.type({
  id: t.string,
  content: t.string,
  timestamp: t.string,
  isUser: t.boolean,
});

export const aiChatRequestCodec = t.type({
  query: t.string,
  previous_messages: t.array(t.string),
});

export const aiChatResponseCodec = t.type({
  success: t.boolean,
  data: t.union([t.undefined, t.partial({
    original_query: t.string,
    human_response: t.string,
    clickhouse_query: t.union([t.null, t.string]),
    organization_id: t.number,
    raw_results: t.union([t.null, t.any]),
    model_used: t.string,
    previous_messages: t.array(t.string),
    meta: t.partial({
      rows_returned: t.number,
      execution_time: t.union([t.null, t.number]),
      previous_messages_count: t.number,
      decision_reason: t.string,
      direct_response: t.boolean,
    }),
  })]),
});

export type AiChatMessage = t.TypeOf<typeof aiChatMessageCodec>;
export type AiChatRequest = t.TypeOf<typeof aiChatRequestCodec>;
export type AiChatResponse = t.TypeOf<typeof aiChatResponseCodec>;
